export var UserDocumentTypeEnum;
(function (UserDocumentTypeEnum) {
    UserDocumentTypeEnum["ID_CARD"] = "ID_CARD";
    UserDocumentTypeEnum["PASSPORT"] = "PASSPORT";
    UserDocumentTypeEnum["RESIDENCE_PERMIT"] = "RESIDENCE_PERMIT";
    UserDocumentTypeEnum["SELFIE"] = "SELFIE";
})(UserDocumentTypeEnum || (UserDocumentTypeEnum = {}));
//# sourceMappingURL=user-document-type.enum.js.map